/**
 * Организационно-правовая форма партнёра.
 *
 * От неё зависит подпись поля с идентификатором: у ИП это ИИН, у остальных
 * БИН. Формат у обоих одинаковый — 12 цифр с общей контрольной суммой,
 * поэтому поле одно, а различает их эта форма.
 *
 * Значения совпадают с `App\Enums\LegalForm` на бэке и с `LegalForm` в
 * мобильном приложении. Порядок здесь — порядок в списке выбора: ТОО и ИП
 * сверху, потому что это подавляющее большинство.
 *
 * В профиле подпись идентификатора приходит с сервера (`identifier_label`) —
 * этот словарь нужен редактору реквизитов, где форму собственности партнёр
 * меняет прямо в форме, до сохранения.
 */

export type LegalFormValue = 'too' | 'ip' | 'ao' | 'other';

export interface LegalFormOption {
  value: LegalFormValue;
  label: string;
  /** Как называется идентификатор: «БИН» или «ИИН». */
  identifierLabel: string;
}

export const LEGAL_FORMS: LegalFormOption[] = [
  { value: 'too', label: 'ТОО', identifierLabel: 'БИН' },
  { value: 'ip', label: 'Индивидуальный предприниматель', identifierLabel: 'ИИН' },
  { value: 'ao', label: 'Акционерное общество', identifierLabel: 'БИН' },
  { value: 'other', label: 'Другая форма', identifierLabel: 'БИН' },
];

/**
 * Подпись, пока форма собственности не выбрана: поле одно на оба номера.
 * Пишется так же, как её отдаёт сервер в `identifier_label`.
 */
export const DEFAULT_IDENTIFIER_LABEL = 'БИН/ИИН';

export function identifierLabelFor(form: LegalFormValue | ''): string {
  return LEGAL_FORMS.find((item) => item.value === form)?.identifierLabel ?? DEFAULT_IDENTIFIER_LABEL;
}
